import { motion } from "framer-motion";
import { LineChart, History, ShoppingCart, Smartphone, Info } from "lucide-react";
import { SectionHead } from "./Features";

const icons = [LineChart, History, ShoppingCart, Smartphone];

export const Everything = ({ t }) => (
  <section id="everything" data-testid="everything-section" className="py-24 md:py-32 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHead kicker={t.everything.kicker} title={t.everything.title} subtitle={t.everything.subtitle} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="lg:col-span-1 rounded-2xl overflow-hidden border border-white/10 min-h-[280px] relative"
        >
          <img
            src="https://images.pexels.com/photos/12935100/pexels-photo-12935100.jpeg"
            alt="POS in use"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
          <p className="absolute bottom-6 left-6 right-6 text-sm text-zinc-300">{t.footer.tagline}</p>
        </motion.div>
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {t.everything.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={item.title}
                data-testid={`everything-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                className="bg-[#0F0F0F] border border-white/10 hover:border-orange-500/50 rounded-2xl p-8 transition-colors duration-300"
              >
                <Icon className="w-5 h-5 text-[#F7931A] mb-5" />
                <h3 className="font-heading text-base font-medium text-white mb-2">{item.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
      <div data-testid="mvp-status-note" className="mt-10 flex items-start gap-3 bg-orange-500/5 border border-orange-500/20 rounded-2xl p-5 text-sm text-zinc-400">
        <Info className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
        {t.everything.note}
      </div>
    </div>
  </section>
);
